import toast from 'react-hot-toast';

export const getErrorMessage = (error, fallbackMessage = 'Something went wrong') => {
  let errorMessage = fallbackMessage;
  if (error?.message) {
    if (error.message.includes('permission-denied')) {
      errorMessage = 'You don\'t have permission to perform this action';
    } else if (error.message.includes('not-found')) {
      errorMessage = 'The requested resource was not found';
    } else if (error.message.includes('network')) {
      errorMessage = 'Network error. Please check your connection';
    } else {
      errorMessage = error.message
        .replace('Firebase:', '')
        .replace('Error:', '')
        .trim();
    }
  }
  return errorMessage;
};

export const handleError = (error, fallbackMessage = 'Something went wrong') => {
  console.error(error);
  const errorMessage = getErrorMessage(error, fallbackMessage);
  toast.error(errorMessage);
  return errorMessage;
};

export const reportError = (error, options = {}) => {
  const { userMessage = 'Something went wrong', toast: toastFlag, showToast, logLabel = '' } = options || {};
  const shouldToast = typeof showToast === 'boolean' ? showToast : (toastFlag !== false);
  const errorCode = error?.code || error?.name;
  const errorMessage = error?.message;
  if (logLabel) {
    console.error(logLabel, { code: errorCode, message: errorMessage, error });
  } else {
    console.error({ code: errorCode, message: errorMessage, error });
  }
  if (shouldToast && userMessage) {
    toast.error(getErrorMessage(error, userMessage));
  }
  return getErrorMessage(error, userMessage);
};